import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, from, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Para endpoints de /bank/, /user/, /dividends/retentions y /projects/ usar Bearer token (Firebase)
    if (req.url.includes('/bank/') || req.url.includes('/user/') || req.url.includes('/dividends/retentions') || req.url.includes('/projects/')) {
      return from(this.getFirebaseToken()).pipe(
        switchMap(token => {
          let authReq = req;
          if (token) {
            // console.log('[AuthInterceptor] Token obtenido, agregando header Authorization');
            authReq = req.clone({
              headers: req.headers.set('Authorization', `Bearer ${token}`)
            });
          } else {
            console.error('[AuthInterceptor] No se pudo obtener el token Firebase. Usuario no autenticado o error al obtener token.');
            // Si no hay token, aún así intentamos la petición (el backend rechazará con 401/403)
          }

          return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
              this.handleAuthError(error);
              return throwError(() => error);
            })
          );
        })
      );
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        this.handleAuthError(error);
        return throwError(() => error);
      })
    );
  }

  private handleAuthError(error: HttpErrorResponse): void {
    if (error.status === 401) {
      console.warn('[AuthInterceptor] Detectado error 401 Unauthorized. Cerrando sesión.');

      // Cerrar alertas abiertas (como loaders)
      Swal.close();

      Swal.fire({
        icon: 'warning',
        title: 'Sesión expirada',
        text: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
        confirmButtonText: 'Ir al Login',
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(() => {
        this.authService.logout().then(() => {
          this.router.navigateByUrl('/login');
          // Recargar para limpiar estados
          window.location.reload();
        });
      });
    }
  }

  private async getFirebaseToken(): Promise<string | null> {
    try {
      const currentUser = this.authService.userAuth.getValue();
      // console.log('[AuthInterceptor] Obteniendo token. Usuario actual:', currentUser ? 'autenticado' : 'no autenticado');

      if (currentUser) {
        // Obtener el token ID de Firebase
        const token = await currentUser.getIdToken();
        // console.log('[AuthInterceptor] Token obtenido exitosamente, longitud:', token?.length || 0);
        return token;
      } else {
        console.warn('[AuthInterceptor] No hay usuario autenticado en userAuth');
        return null;
      }
    } catch (error) {
      console.error('[AuthInterceptor] Error obteniendo token Firebase:', error);
      return null;
    }
  }
}
